// import React, { useState } from "react";
// import { ChevronDown, ChevronUp } from "lucide-react";
// import SnagsChat from "../Snags/ChatWindow";
// import SiteCommunications from "./SiteCommunications";

// const CommunicationsPanel = ({setTab,setSnagId}) => {
//   const [isExpanded, setIsExpanded] = useState(true);
//   const siteId = localStorage.getItem("site");

//   return (
//     <div
//       className="w-full flex-none h-full flex  flex-col"
//       style={{
//         overflowY: "auto",
//       }}
//     >
//       {/* Site Communications Section */}
//       <div className="flex-1 flex flex-col">
//         {/* <button
//           onClick={() => setIsExpanded(!isExpanded)}
//           className="flex items-center justify-between p-4 bg-white border-b hover:bg-gray-50"
//         >
//           <span className="font-semibold text-gray-700">Site Updates</span>
//           {isExpanded ? (
//             <ChevronUp className="w-5 h-5 text-gray-500" />
//           ) : (
//             <ChevronDown className="w-5 h-5 text-gray-500" />
//           )}
//         </button> */}

//         <div className="flex-1 overflow-y-auto p-4">
//           <SiteCommunications setTab={setTab} setSnagId={setSnagId}/>
//         </div>
//         {/* {isExpanded && (
//         )} */}
//       </div>

//       {/* Chat Window Section - Adjusted height */}
//       {/* <div className=" px-6 border-t"> */}
//       {/* <SnagsChat /> */}
//     </div>
//   );
// };

// export default CommunicationsPanel;

// import React, { useState } from "react";
// import { ChevronDown, ChevronUp } from "lucide-react";
// import SiteCommunications from "./SiteCommunications";

// const CommunicationsPanel = ({
//   setTab,
//   setSnagId,
//   isExpanded,
//   setIsExpanded,
// }) => {
//   const siteId = localStorage.getItem("site");

//   return (
//     <div
//       className="h-full w-full flex items-center justify-start flex-col relative transition-all duration-300"
//     // style={{
//     //   overflowY: isExpanded ? "auto" : "hidden",
//     // }}
//     >
//       {/* Toggle Button */}
//       <button
//         onClick={() => setIsExpanded(!isExpanded)}
//         className={`absolute top-[45%] z-50 left-0 -translate-x-full bg-white border-l border-y border-gray-200 rounded-l-md
//         h-12 px-[0.2px] hover:bg-gray-50 transition-colors shadow-sm`}
//         title={isExpanded ? "Collapse panel" : "Expand panel"}
//       >
//         {isExpanded ? (
//           <ChevronDown className="w-4 h-4 text-gray-600 rotate-[-90deg]" />
//         ) : (
//           <ChevronDown className="w-4 h-4 text-gray-600 rotate-[90deg]" />
//         )}
//       </button>

//       {/* Site Communications Section */}
//       <div className={`w-full h-full ${isExpanded ? "opacity-100" : "opacity-0 invisible"} transition-opacity duration-200 pr-2 pt-2`}>
//         <SiteCommunications setTab={setTab} setSnagId={setSnagId} />
//       </div>

//       {!isExpanded && (
//         <div
//           className="absolute inset-0 flex flex-col items-center pt-20 border-l bg-white cursor-pointer hover:bg-gray-50 transition-colors"
//           onClick={() => setIsExpanded(true)}
//         >
//           <div className="rotate-90 text-gray-500 font-medium whitespace-nowrap tracking-wider text-sm">
//             Communications
//           </div>
//         </div>
//       )}

//       {/* Chat Window Section - Adjusted height */}
//       {/* <div className=" px-6 border-t"> */}
//       {/* <SnagsChat /> */}
//     </div>
//   );
// };

// export default CommunicationsPanel;
import React from "react";
import { ChevronDown } from "lucide-react";
import SiteCommunications from "./SiteCommunications";

const CommunicationsPanel = ({
  setTab,
  setSnagId,
  isExpanded,
  setIsExpanded,
  hideArrow = false,
}) => {
  const siteId = localStorage.getItem("site");

  return (
    <div className="h-full w-full flex items-center justify-start flex-col relative transition-all duration-300">
      {/* Toggle Button - HIDE when profile card is open */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className={`absolute top-[45%] z-10 left-0 -translate-x-full bg-white border-l border-y border-gray-200 rounded-l-md
        h-12 px-[0.2px] hover:bg-gray-50 transition-all duration-200 shadow-sm ${hideArrow ? "opacity-0 pointer-events-none" : "opacity-100"
          }`}
        title={isExpanded ? "Collapse panel" : "Expand panel"}
      >
        {isExpanded ? (
          <ChevronDown className="w-4 h-4 text-gray-600 rotate-[-90deg]" />
        ) : (
          <ChevronDown className="w-4 h-4 text-gray-600 rotate-[90deg]" />
        )}
      </button>

      {/* Site Communications Section */}
      <div
        className={`w-full h-full ${isExpanded ? "opacity-100" : "opacity-0 invisible"
          } transition-opacity duration-200 pr-2 pt-2`}
      >
        <SiteCommunications setTab={setTab} setSnagId={setSnagId} />
      </div>

      {!isExpanded && (
        <div
          className="absolute inset-0 flex flex-col items-center pt-20 border-l bg-white cursor-pointer hover:bg-gray-50 transition-colors"
          onClick={() => setIsExpanded(true)}
        >
          <div className="rotate-90 text-gray-500 font-medium whitespace-nowrap tracking-wider text-sm">
            Communications
          </div>
        </div>
      )}
    </div>
  );
};

export default CommunicationsPanel;
